import React, { useState,useRef,useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Constants } from '../lib/const/constants';
import getCurrencySymbol from '../lib/currenyUtils';
import { encryptPayload } from '../utils/encryption';
import { ArrowLeft, QrCode, Landmark, Loader2 } from 'lucide-react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function Banks() {
  const location = useLocation();
  const banks = location.state?.banks || [];
  const transactionid = location.state?.transactionid;
  // console.log('Transaction Id', transactionid);
  const extrernal_user_id = location.state?.external_user_id;
  const amount = location.state?.amount;
  const currency = location.state?.currency;
  const transfer_fee = location.state?.transfer_fee;
  const service_fee = location.state?.service_fee;
  // console.log('id', extrernal_user_id);
  // console.log('Api data', location.state);

  const clearBankCustomerWalletNumber = sessionStorage.getItem(
    'clearBankCustomerWalletNumber',
  );
  const clearBankCustomerSortCode = sessionStorage.getItem(
    'clearBankCustomerSortCode',
  );
  const login_workspaces = JSON.parse(sessionStorage.getItem('login_workspaces'))
  const account_name = login_workspaces?.[0]?.name
  // console.log("Account name",account_name)
  // console.log("Account Number")

  const [selectedbank, setSelectedbank] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [qrData, setQrData] = useState(null);
const [qrLoading, setQrLoading] = useState(false);
const [qrError, setQrError] = useState(false);
// 'qr' = scan-to-pay view (default), 'bank' = choose-your-bank view.
// Remembered per transaction so returning from the bank's page reopens the bank list, not the QR.
const payModeKey = `banks_paymode_${transactionid}`;
const [payMode, setPayModeState] = useState(
  () => sessionStorage.getItem(payModeKey) || 'qr',
);
const setPayMode = (mode) => {
  sessionStorage.setItem(payModeKey, mode);
  setPayModeState(mode);
};
const qrAutoRequestedRef = useRef(false);
const sendFlowPromiseRef = useRef(null);

const navigate = useNavigate();
const [timeleft, setTimeleft] = useState(180);

const minutes = Math.floor(timeleft / 60);
const seconds = timeleft % 60;
const formattedtime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;


  const payload = location.state?.payload || {};

  // Total payable = send amount + transfer fee + service fee (e.g. 10 + 1 + 1 = 12.00)
  const transferFee = parseFloat(transfer_fee ?? payload.transfer_fee) || 0;
  const serviceFee = parseFloat(service_fee ?? payload.service_fee) || 0;
  const totalAmount = amount
    ? (parseFloat(amount) + transferFee + serviceFee).toFixed(2)
    : amount;


const createSendFlow   = async () => {
    // if (sendFlowIdRef.current) return sendFlowIdRef.current;
  const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
  const token = sessionStorage.getItem('login_token');
  const staff_login_id = sessionStorage.getItem('staff_login_id');

  const encryptedPayload = await encryptPayload({
    contact_id: payload.contactId,
    workspace_id: login_workspaces_id,
    reason_code: payload.transferReason,
    full_name: payload.bank_account_name,
    sort_code: payload.code,
    createTransaction: true,
    currency: payload.currency,
    account_number: payload.account,
    type: 'local',
    currency_cloud_balance: 0,
    clear_bank_balance: 0,
    total_balance: 0,
    beneficiaryId: payload.id,
    reference: payload.ref || account_name,
    reason: payload.transferReason,
    staff_login_id,
    status: 'waiting for funds',
    flow: 'sendFlow',
    transfer_fee: payload.transfer_fee,
    service_fee: payload.service_fee,
    method: 'bank',
    platform: 'web',
    extraParamValidation: 'trustedfromweb',
  });

  const resp = await axios.post(
    Constants.BASE_URL + 'API-FX-240-SEND-FLOW',
    encryptedPayload,
    {
      headers: {
        fx_key: Constants.SUBSCRIPTION_KEY,
        Authorization: 'Bearer ' + JSON.parse(token),
      },
    },
  );

  return resp?.data?.data?.id;
};

const paymentConfirmation = () => {
  
  const savedId = sessionStorage.getItem(`sendflow_${transactionid}`);
  if (savedId) return Promise.resolve(savedId);

  
  if (!sendFlowPromiseRef.current) {
    sendFlowPromiseRef.current = createSendFlow()
      .then((id) => {
        if (!id) throw new Error('Transaction not created');
        sessionStorage.setItem(`sendflow_${transactionid}`, id);
        return id;
      })
      .catch((err) => {
        sendFlowPromiseRef.current = null; 
        throw err;
      });
  }
  return sendFlowPromiseRef.current;
};

  const handlecontinue = async () => {
    if (loading) return; 
    setLoading(true);
    try {
      const transactionId = await paymentConfirmation();
      console.log('transactionId',transactionId);
      const requestBody = {
        institution_id: selectedbank?.id,
        institution_name: selectedbank?.name,
        platform: 'web',
        return_url:window.location.origin +'/YapilyStatus',
        account_number: String(
          clearBankCustomerWalletNumber ||
            Constants.ACCOUNT_DETAILS?.[0]?.GBP?.[0]?.['Account Number'],
        ),
        sort_code: String(
          clearBankCustomerSortCode ||
            Constants.ACCOUNT_DETAILS?.[0]?.GBP?.[0]?.['Sort Code'],
        ),
        amount: totalAmount,
        reference: 'banking payment',
        account_name:clearBankCustomerWalletNumber ? account_name:'fxmaster limited',
        currency: currency,
      };

      // console.log('Request Body:', requestBody);
      const response = await axios.post(
        'https://banking.fxmaster.co.uk/api/yapily/payments/single/start/',
        requestBody,
        {
          headers: {
            'X-Correlation-Id': transactionid,
            'X-External-User-Id': extrernal_user_id,
            'X-Idempotency-Key': transactionid,
            'Content-Type': 'application/json',
          },
        },
      );
      // console.log(response.data);
      const url = response.data.authorisation_url;
      // console.log('url', url);
      if (url) {
        // Keep showing "Processing" until the browser leaves for the bank's page
        window.location.href = url;
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.log('Status:', error.response?.status);
      // console.log('Response:', error.response?.data);
      // console.log('Headers:', error.response?.headers);
      // console.log('Message:', error.message);
      setLoading(false);
    }
  };


  const handleGenerateQr = async () => {
  if (qrLoading) return;
  setQrLoading(true);
  try {
    const transactionsId = await paymentConfirmation();
      console.log('transactionId2222222',transactionsId); 
    const login_workspace_id = sessionStorage.getItem('login_workspaces_id');
    const response = await axios.post(
      'https://banking.fxmaster.co.uk/api/yapily/paybyqr/',
      {
        user_id: login_workspace_id,
        external_user_id: login_workspace_id,
        transaction_id: transactionsId,
        account_number: Constants.ACCOUNT_DETAILS?.[0]?.GBP?.[0]?.['Account Number'],
        sort_code: Constants.ACCOUNT_DETAILS?.[0]?.GBP?.[0]?.['Sort Code'],
        account_name: 'Fxmaster Limited',
        amount: totalAmount,
        currency,
        reference: payload.transferReason,
        return_url: window.location.origin + '/YapilyStatus',
        platform: 'web',
      },
      { auth: { username: 'banking@fxmaster.co.uk', password: 'xHGmEkVpFDMZJoir' } },
    );
    setQrData({ qrimg: response.data.qrcode_url, journey_id: response.data.journey_id });
    setTimeleft(180);
    setQrError(false);
  } catch (error) {
    console.log('QR Status:', error.response?.status);
    setQrError(true);
    toast.error('Unable to generate QR code');
  } finally {
    setQrLoading(false);
  }
};

const checkstatus = useCallback(async () => {
  if (!qrData?.journey_id) return;
  const login_workspace_id = sessionStorage.getItem('login_workspaces_id');
  try {
    const resp = await axios.get(
      `https://banking.fxmaster.co.uk/api/yapily/payments/${qrData.journey_id}/status/`,
      {
        headers: {
          accept: '*/*',
          'X-External-User-Id': login_workspace_id,
        },
      },
    );
    const status = (resp.data?.status || '').toUpperCase();
    if (status !== 'PENDING' && status !== 'AWAITING_BANK_SELECTION') {
      navigate('/YapilyStatus', { state: { status } });
    }
  } catch (err) {
    console.error(err);
  }
}, [qrData?.journey_id, navigate]);

useEffect(() => {
  // Only count down / poll while the QR view is open
  if (!qrData?.qrimg || payMode !== 'qr') return;
  const timer = setInterval(() => {
    setTimeleft((prev) => {
      if (prev <= 1) {
        clearInterval(timer);
        navigate('/YapilyStatus', { state: { status: 'FAILED' } });
        return 0;
      }
      return prev - 1;
    });
  }, 1000);

  const poll = setInterval(checkstatus, 10000);
  checkstatus();
  return () => {
    clearInterval(timer);
    clearInterval(poll);
  };
}, [qrData?.qrimg, payMode, navigate, checkstatus]);

// Show the QR straight away (no button): generate it whenever the QR view is open and no QR exists
useEffect(() => {
  if (payMode !== 'qr' || qrData || qrError || !amount || !currency) return;
  if (qrAutoRequestedRef.current) return;
  qrAutoRequestedRef.current = true;
  handleGenerateQr().finally(() => {
    qrAutoRequestedRef.current = false;
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [payMode, qrData, qrError]);

// Browsers may restore this page from the back/forward cache with "Processing" still on; reset it
useEffect(() => {
  const onPageShow = (e) => {
    if (e.persisted) setLoading(false);
  };
  window.addEventListener('pageshow', onPageShow);
  return () => window.removeEventListener('pageshow', onPageShow);
}, []);

const showBankOption = () => {
  // Drop the QR so its expiry timer can't redirect away while the user picks a bank
  setQrData(null);
  setPayMode('bank');
};

const showQrOption = () => {
  setQrError(false);
  setPayMode('qr');
};

  const filteredbanks = banks.filter((bank) => {
    return bank.name.toLowerCase().includes(search.toLowerCase());
  });

  const orDivider = (
    <div className="my-6 flex items-center gap-3 text-sm text-gray-400">
      <span className="flex-1 h-px bg-gray-200" />
      or
      <span className="flex-1 h-px bg-gray-200" />
    </div>
  );

  const amountRow = (
    <div className="mt-6 flex items-center justify-between rounded-lg bg-white border border-gray-200 px-4 py-3">
      <span className="text-gray-600 font-medium">Total</span>
      <span className="text-xl font-semibold text-black">
        {getCurrencySymbol(currency)} {totalAmount}
      </span>
    </div>
  );
      return (
  <div className="max-w-6xl mx-auto p-6">
    <ToastContainer position="top-right" autoClose={3000} />

    <div className="flex items-center mb-8">
      <button
        onClick={() => window.history.back()}
        className="text-2xl mr-1 hover:text-blue-600"
      >
        <ArrowLeft className="w-5 h-5" />
      </button>
      <h2 className="text-2xl font-semibold">Back</h2>
    </div>

    <div className="max-w-xl mx-auto">
      {payMode === 'qr' ? (
        /* ── QR VIEW (default) ── */
        <div className="rounded-lg border border-gray-200 bg-gray-100 p-6 text-center">
          <p className="text-lg font-medium mb-1">Scan to pay</p>
          <p className="text-sm text-gray-500 mb-4">
            Scan the QR code using your banking app
          </p>

          {qrData?.qrimg && timeleft > 0 ? (
            <>
              <img
                src={qrData.qrimg}
                alt="Payment QR code"
                className="mx-auto w-64 h-64 object-contain bg-white p-2 rounded-lg"
              />

              <div className="mt-4 flex items-center justify-center gap-2 text-sm text-gray-500">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#D26521] opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-[#D26521]"></span>
                </span>
                Waiting for confirmation from your bank...
              </div>

              <div className="mt-3">
                <p className="text-sm text-gray-500">QR code expires in</p>
                <p className="mt-1 text-2xl font-bold text-[#D26521]">{formattedtime}</p>
              </div>

              <div className="mt-6 text-left">
                <p className="text-[13px] font-semibold text-[#1f2a44] mb-2">How to pay</p>
                <ol className="text-[13px] text-gray-600 space-y-1 list-decimal list-inside">
                  <li>Scan the QR code above</li>
                  <li>Your bank&apos;s app will open. Authenticate to continue</li>
                  <li>Check the payment details and approve the payment in your banking app</li>
                </ol>
              </div>
            </>
          ) : qrError ? (
            /* Generation failed: let the user retry */
            <div className="py-6">
              <p className="text-sm text-red-600 mb-4">Unable to generate QR code.</p>
              <button
                onClick={handleGenerateQr}
                disabled={qrLoading || loading}
                className="inline-flex items-center gap-2 px-5 py-3 rounded-lg text-white font-medium bg-blue-600 hover:bg-blue-700"
              >
                <QrCode className="w-5 h-5" />
                {qrLoading ? 'Generating...' : 'Try again'}
              </button>
            </div>
          ) : amount && currency ? (
            <div className="mx-auto w-64 h-64 flex flex-col items-center justify-center gap-3 bg-white rounded-lg text-gray-500 text-sm">
              <Loader2 className="w-8 h-8 animate-spin text-[#D26521]" />
              Generating QR code...
            </div>
          ) : null}

          {(!amount || !currency) && (
            <p className="mt-4 text-sm text-red-600">Amount or currency is missing.</p>
          )}

          {amountRow}

          {orDivider}

          <button
            onClick={showBankOption}
            className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-lg border border-blue-600 text-blue-600 font-medium bg-white hover:bg-blue-50 transition-colors"
          >
            <Landmark className="w-5 h-5" />
            Pay Via  Online Banking
          </button>
        </div>
      ) : (
        /* ── BANK VIEW ── */
        <div>
          <p className="text-lg mb-3">Choose your bank:</p>

          <input
            type="text"
            placeholder="Search all banks"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-4 py-3 mb-6 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <div className="max-h-[480px] overflow-y-auto pr-1">
            {filteredbanks.map((bank) => (
              <div
                key={bank.id}
                onClick={() =>
                  setSelectedbank((prev) => (prev?.id === bank.id ? null : bank))
                }
                className={`p-5 mb-3 rounded-lg cursor-pointer bg-gray-100 transition-all ${
                  selectedbank?.id === bank.id
                    ? 'border-2 border-blue-500'
                    : 'border border-gray-200'
                }`}
              >
                <div className="flex items-center justify-between w-full">
                  <div className="flex items-center">
                    <img
                      src={bank.media?.find((m) => m.type === 'logo')?.source}
                      alt={bank.name}
                      className="w-12 h-12 rounded-full object-contain bg-white p-1"
                    />
                    <span className="ml-4 text-lg font-medium">{bank.name}</span>
                  </div>
                  {bank.is_connected && (
                    <span className="text-green-600 font-semibold">Linked</span>
                  )}
                </div>
              </div>
            ))}

            {filteredbanks.length === 0 && (
              <h3 className="text-center text-gray-500">No Banks Found</h3>
            )}
          </div>

          {amountRow}

          <button
            onClick={handlecontinue}
            disabled={!selectedbank || loading || qrLoading}
            className={`w-full mt-6 py-3 rounded-lg text-white font-medium transition-colors ${
              selectedbank
                ? 'bg-[rgb(210,101,33)] hover:bg-[rgb(184,86,28)]'
                : 'bg-gray-400 cursor-not-allowed'
            }`}
          >
            {loading ? (
              <span className="inline-flex items-center justify-center gap-2">
                <Loader2 className="w-5 h-5 animate-spin" />
                Processing...
              </span>
            ) : (
              'Continue'
            )}
          </button>

          {orDivider}

          <button
            onClick={showQrOption}
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-lg border border-blue-600 text-blue-600 font-medium bg-white hover:bg-blue-50 transition-colors"
          >
            <QrCode className="w-5 h-5" />
            Pay Via QR code
          </button>
        </div>
      )}
    </div>
  </div>
);
}